import { ICourseService } from "../../../core/services/course";
import { injectable } from "inversify";
import databaseInstance from "../../index";
import appConfig from "appConfig";
import Cookie from "js-cookie";
import { CommonConstants } from "constants/common";
import { RecurringUpdateOptions } from "containers/events/EventsAdminContainer/domain";

@injectable()
export class EventsService implements ICourseService {
  private dbInstance: any = databaseInstance;

  private static instance: EventsService;

  constructor() {
    EventsService.instance = this;
  }

  public static getInstance() {
    if (!EventsService.instance) {
      EventsService.instance = new EventsService();
    }
    return EventsService.instance;
  }

  public uploadCoverImage: (eventId: number, image: any) => Promise<void> = (
    eventId,
    image
  ) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/events/${eventId}/cover-image`, image)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    });
  };

  public getEvent: (groupId: number, eventId: any, query?: any) => Promise<void> = (groupId, eventId, query="") => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance.get(`/groups/${groupId}/events/${eventId}${query}`)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public getEventAdmin: (groupId: number, eventId: any, query?: any) => Promise<void> = (groupId, eventId, query="") => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance.get(`/groups/${groupId}/events/${eventId}/admin${query}`)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public publishEvent: (eventId: number, data?: any) => Promise<void> = (eventId, data) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/events/${eventId}/published-events`, data ? data : undefined)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    });
  };

  public unpublishEvent: (eventId: number, data?: any) => Promise<void> = (eventId, data) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .delete(`/events/${eventId}/published-events`, data ? {
          data,
        } : undefined)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    });
  };

  public updateCoverImage: (
    eventId: number,
    coverImage: any
  ) => Promise<void> = (eventId, coverImage) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/events/${eventId}/cover-image`, coverImage)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    });
  };

  public getEvents: (
    groupId: number,
    query?: string,
    page?: number
  ) => Promise<void> = (
    groupId,
    query = "",
    page = 1
  ) => {
      return new Promise<void>((resolve, reject) => {
        this.dbInstance
          .get(`/groups/${groupId}/events?page=${page}${query}`)
          .then((response: any) => {
            resolve(response);
          }).catch((error: any) => {
            reject(error)
            new Error("Something went wrong!")
          })
      });
    };

      public getEventsAdmin: (
      groupId: number,
      query?: string,
      page?: number
    ) => Promise<void> = (
      groupId,
      query = "",
      page = 1
    ) => {
        return new Promise<void>((resolve, reject) => {
          this.dbInstance
            .get(`/groups/${groupId}/admin-events?page=${page}${query}`)
            .then((response: any) => {
              resolve(response);
            }).catch((error: any) => {
              reject(error)
              new Error("Something went wrong!")
            })
        });
      };

    public getAllEvents: (
      groupId: number,
      query?: string,
    ) => Promise<void> = (
      groupId,
      query = "",
    ) => {
      return new Promise<void>((resolve, reject) => {
        this.dbInstance
        .get(`/groups/${groupId}/events${query}`)
          .then((response: any) => {
            resolve(response);
          }).catch((error: any) => {
            reject(error)
            new Error("Something went wrong!")
          })
      })
    }

    public getAllEventsAdmin: (
      groupId: number,
      query?: string,
    ) => Promise<void> = (
      groupId,
      query = "",
    ) => {
      return new Promise<void>((resolve, reject) => {
        this.dbInstance
        .get(`/groups/${groupId}/admin-events${query}`)
          .then((response: any) => {
            resolve(response);
          }).catch((error: any) => {
            reject(error)
            new Error("Something went wrong!")
          })
      })
    }

  public getAvailableEventsForCourses: (
    groupId: number,
    query?: string,
  ) => Promise<void> = (
    groupId,
    query = "",
  ) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
      .get(`/groups/${groupId}/events/available-events-for-courses${query}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public deleteEvent: (eventId: number, recurringUpdateOption?: RecurringUpdateOptions) => Promise<void> = (eventId, recurringUpdateOption) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance.delete(`/events/${eventId}`, recurringUpdateOption ? {
        data: {
          recurring_delete_option: recurringUpdateOption,
        }
      } : undefined)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public createEvent: (
    groupId: number,
    payload: any
  ) => Promise<void> = (groupId, payload) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/events`, payload)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });;
    });
  };

  public updateEvent: (
    groupId: number,
    eventId: number,
    payload: any
  ) => Promise<void> = (
    groupId,
    eventId,
    payload
  ) => {
      return new Promise<void>((resolve, reject) => {
        this.dbInstance
          .put(`/groups/${groupId}/events/${eventId} `, {
            ...payload
          })
          .then((response: any) => {
            resolve(response);
          })
          .catch((error: any) => {
            reject(error)
            new Error("Something went wrong!")
          });
      });
    };

  public rsvpEvent: (
    eventId: number,
    data?: any
  ) => Promise<void> = (eventId, data) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/events/${eventId}/rsvps`, data)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });;
    });
  };

  public removeEventRsvp: (
    eventId: number,
    data?: any
  ) => Promise<void> = (eventId, data) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .delete(`/events/${eventId}/rsvps`, data ? {
          data: data,
        } : undefined)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });;
    });
  };

  public getEventAttendees: (
    eventId: number,
    query?: string,
    limit?: string
  ) => Promise<void> = (
    eventId,
    query,
    limit
  ) => {
      return new Promise<void>((resolve, reject) => {
        this.dbInstance
          .get(`/events/${eventId}/rsvps${query && query.length > 0 ? query : ''}${limit ? limit : ''}`)
          .then((response: any) => {
            resolve(response);
          }).catch((error: any) => {
            reject(error)
            new Error("Something went wrong!")
          })
      });
    };

  public getAdminEventAttendees: (
    groupId: number,
    eventId: number,
    query?: string,
    limit?: string
  ) => Promise<void> = (
    groupId,
    eventId,
    query,
    limit
  ) => {
      return new Promise<void>((resolve, reject) => {
        this.dbInstance
          .get(`/groups/${groupId}/events/${eventId}/admin-rsvps${query && query.length > 0 ? query : ''}${limit ? limit : ''}`)
          .then((response: any) => {
            resolve(response);
          }).catch((error: any) => {
            reject(error)
            new Error("Something went wrong!")
          })
      });
    };

  public loadMore: (url: string) => Promise<void> = (url) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(url)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    });
  };

  public getEventPosts: (
      groupId: number, 
      eventId: number,
      query?: string,
    ) => Promise<void> = ( groupId, eventId, query='' )=> {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(
          `/groups/${groupId}/postables/${eventId}/posts?postable_type=event&sort=published_at:desc&include=postable${query}`
        )
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    });
  };

  public createEventPost: (
    groupId: number,
    eventId: number,
    postObject: any
  ) => Promise<void> = (groupId, eventId, postObject) => {
    return new Promise<void>((resolve, reject) => {
      return this.dbInstance
        .post(`/groups/${groupId}/postables/${eventId}/posts`, postObject)
        .then((response: any) => {
          if (response && response.data) {
            resolve(response.data);
          }
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public exportAttendeesList: (
    eventId: number
  ) => Promise<void> = (eventId) => {
    return new Promise<void>((resolve, reject) => {
      return this.dbInstance
        .post(`/events/${eventId}/rsvps/export`)
        .then((response: any) => {
          if (response) {
            resolve(response);
          }
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public getEventUninvitedMembers: (
    eventId: string,
    query?: string,
  ) => Promise<void> = (eventId, query = "") => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/events/${eventId}/non-invites?search=${encodeURIComponent(query)}`)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public getEventInvitedMembers: (
    eventId: string,
    query?: string,
  ) => Promise<void> = (eventId, query = "") => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/events/${eventId}/invites?search=${encodeURIComponent(query)}`)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
    };

  public loadMoreEventInvitedMembers: (url: string) => Promise<void> = (url) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(url)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public inviteEventAttendees: (
    eventId: number,
    userIds: any
  ) => Promise<void> = (eventId, userIds) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/events/${eventId}/invites`, { user_ids: userIds })
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    });
  };

  public inviteAllEventAttendees: (eventId: number) => Promise<void> = (eventId,) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/events/${eventId}/invites`, {})
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public removeInvitedAttendee: (
    eventId: number, 
    userId: number
  ) => Promise<void> = (eventId, userId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .delete(`/events/${eventId}/invites`, {
          data: {
            user_ids: [userId]
          }
        })
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });;
    });
  };

  public purchaseEvent: (
    eventId: number, 
    paymentMethodId: number
  ) => Promise<void> = (eventId, paymentMethodId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/events/${eventId}/rsvps`, 
          {
            payment_method_id: paymentMethodId
          }
        )
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public featureEvent: (
    groupId: number,
    eventId: number, 
  ) => Promise<void> = (groupId, eventId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/events/${eventId}/featured`)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public unfeatureEvent: (
    groupId: number,
    eventId: number, 
  ) => Promise<void> = (groupId, eventId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .delete(`/groups/${groupId}/events/${eventId}/featured`)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public getFeaturedEvents: (
    groupId: number,
  ) => Promise<void> = (groupId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/events/featured`)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public addEventHosts: (
    groupId: number,
    eventId: number,
    userData: any
  ) => Promise<void> = (groupId, eventId, userData) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`groups/${groupId}/events/${eventId}/hosts`, userData)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    })
  };

  public deleteEventHosts: (
    groupId: number,
    eventId: number,
    userId: any,
    data?: any
  ) => Promise<void> = (groupId, eventId, userId, data=undefined) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .delete(`groups/${groupId}/events/${eventId}/hosts/${userId}`, {
          data: data,
        })
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    })
  };

  public editEventHosts: (
    groupId: number,
    eventId: number,
    userId: any,
    payload: any
  ) => Promise<void> = (groupId, eventId, userId, payload) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`groups/${groupId}/events/${eventId}/hosts/${userId}`, payload)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    })
  };

  public editEventReminder: (
    groupId: number,
    eventId: number,
    reminderId: number,
    payload: any
  ) => Promise<void> = (groupId, eventId, reminderId, payload) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .put(`groups/${groupId}/events/${eventId}/reminders/${reminderId}`, payload)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    })
  };

  public getEventICSFile = async (eventId: any, rsvpId: number) => {
      const token: any = Cookie.get(CommonConstants.USER_TOKEN)
        ? Cookie.get(CommonConstants.USER_TOKEN)
        : null;

    try {
      const response = await fetch(
        `${appConfig.api.baseUrl}/events/${eventId}/download-ics-file?rsvp_id=${rsvpId}`,
        {
          method: "GET",
          headers: {
            Authorization:
              `Bearer ${token}`, // If needed
          },
        }
      );

      if (!response.ok) throw new Error("Failed to download");
      return response;
    } catch (error) {
      return error;
    }
  };

  public adminRsvpMemberToEvent: (
    groupId: number,
    eventId: number,
    payload: number[],
  ) => Promise<void> = (groupId, eventId, payload) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`groups/${groupId}/events/${eventId}/admin-add-rsvps`, {
          user_ids: payload
        })
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    })
  };

  public adminCancelRsvpForMember: (
    groupId: number,
    eventId: number,
    payload: number[],
  ) => Promise<void> = (groupId, eventId, payload) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .delete(`groups/${groupId}/events/${eventId}/admin-remove-rsvps`, {
          data: {
            "user_ids": payload
          }
        })
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        })
    })
  };


  public getRSVPedMembers: (groupId: number, eventId: number, query?: string) => Promise<void> = (groupId, eventId, query = "") => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/events/${eventId}/non-rsvps${query}`)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public createEventReminder: (groupId: number, eventId: number, data: any) => Promise<void> = (groupId, eventId, data) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/events/${eventId}/reminders`, data)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public updateEventReminder: (groupId: number, eventId: number, reminderId: number, data: any) => Promise<void> = (groupId, eventId, reminderId, data) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .put(`/groups/${groupId}/events/${eventId}/reminders/${reminderId}`, data)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public deleteEventReminder: (groupId: number, eventId: number, reminderId: number, data?: any) => Promise<void> = (groupId, eventId, reminderId, data) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .delete(`/groups/${groupId}/events/${eventId}/reminders/${reminderId}`, data ? {
          data,
        } : undefined)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

}
